var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPauseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 0.333313C12.7799 0.333313 0.833252 12.28 0.833252 27C0.833252 41.72 12.7799 53.6666 27.4999 53.6666C42.2199 53.6666 54.1666 41.72 54.1666 27C54.1666 12.28 42.2199 0.333313 27.4999 0.333313ZM24.8333 37.6666H19.4999V16.3333H24.8333V37.6666ZM35.4999 37.6666H30.1666V16.3333H35.4999V37.6666Z",
    fill: "#594AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPauseCircle);
export default __webpack_public_path__ + "static/media/icon-pause-circle.58f143c70029ef9f03c27c7110553cc1.svg";
export { ForwardRef as ReactComponent };